import RecipesRoutes from './RecipesRoutes';

export default RecipesRoutes;
